/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as VerifyEmailImport } from './routes/verify-email'
import { Route as TermsAndConditionsImport } from './routes/terms-and-conditions'
import { Route as ResetPasswordImport } from './routes/reset-password'
import { Route as RegisterImport } from './routes/register'
import { Route as PrivacyPolicyImport } from './routes/privacy-policy'
import { Route as PricingImport } from './routes/pricing'
import { Route as LoginImport } from './routes/login'
import { Route as ForgotPasswordImport } from './routes/forgot-password'
import { Route as EmailVerificationImport } from './routes/email-verification'
import { Route as DiscoverImport } from './routes/discover'
import { Route as DashboardImport } from './routes/dashboard'
import { Route as IndexImport } from './routes/index'
import { Route as SettingsPaymentImport } from './routes/settings.payment'
import { Route as SettingsMySubscriptionImport } from './routes/settings.my-subscription'
import { Route as SettingsMyAccountImport } from './routes/settings.my-account'
import { Route as PublicSearchImport } from './routes/public.search'
import { Route as SettingsPaymentEditPaymentImport } from './routes/settings.payment_.edit-payment'
import { Route as SettingsMyAccountEditProfileImport } from './routes/settings.my-account_.edit-profile'
import { Route as DiscoverPlatformUserSearchUUIDImport } from './routes/discover_.$platform.$userSearchUUID'

// Create/Update Routes

const VerifyEmailRoute = VerifyEmailImport.update({
  path: '/verify-email',
  getParentRoute: () => rootRoute,
} as any)

const TermsAndConditionsRoute = TermsAndConditionsImport.update({
  path: '/terms-and-conditions',
  getParentRoute: () => rootRoute,
} as any)

const ResetPasswordRoute = ResetPasswordImport.update({
  path: '/reset-password',
  getParentRoute: () => rootRoute,
} as any)

const RegisterRoute = RegisterImport.update({
  path: '/register',
  getParentRoute: () => rootRoute,
} as any)

const PrivacyPolicyRoute = PrivacyPolicyImport.update({
  path: '/privacy-policy',
  getParentRoute: () => rootRoute,
} as any)

const PricingRoute = PricingImport.update({
  path: '/pricing',
  getParentRoute: () => rootRoute,
} as any)

const LoginRoute = LoginImport.update({
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const ForgotPasswordRoute = ForgotPasswordImport.update({
  path: '/forgot-password',
  getParentRoute: () => rootRoute,
} as any)

const EmailVerificationRoute = EmailVerificationImport.update({
  path: '/email-verification',
  getParentRoute: () => rootRoute,
} as any)

const DiscoverRoute = DiscoverImport.update({
  path: '/discover',
  getParentRoute: () => rootRoute,
} as any)

const DashboardRoute = DashboardImport.update({
  path: '/dashboard',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const SettingsPaymentRoute = SettingsPaymentImport.update({
  path: '/settings/payment',
  getParentRoute: () => rootRoute,
} as any)

const SettingsMySubscriptionRoute = SettingsMySubscriptionImport.update({
  path: '/settings/my-subscription',
  getParentRoute: () => rootRoute,
} as any)

const SettingsMyAccountRoute = SettingsMyAccountImport.update({
  path: '/settings/my-account',
  getParentRoute: () => rootRoute,
} as any)

const PublicSearchRoute = PublicSearchImport.update({
  path: '/public/search',
  getParentRoute: () => rootRoute,
} as any)

const SettingsPaymentEditPaymentRoute = SettingsPaymentEditPaymentImport.update(
  {
    path: '/settings/payment/edit-payment',
    getParentRoute: () => rootRoute,
  } as any,
)

const SettingsMyAccountEditProfileRoute =
  SettingsMyAccountEditProfileImport.update({
    path: '/settings/my-account/edit-profile',
    getParentRoute: () => rootRoute,
  } as any)

const DiscoverPlatformUserSearchUUIDRoute =
  DiscoverPlatformUserSearchUUIDImport.update({
    path: '/discover/$platform/$userSearchUUID',
    getParentRoute: () => rootRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardImport
      parentRoute: typeof rootRoute
    }
    '/discover': {
      id: '/discover'
      path: '/discover'
      fullPath: '/discover'
      preLoaderRoute: typeof DiscoverImport
      parentRoute: typeof rootRoute
    }
    '/email-verification': {
      id: '/email-verification'
      path: '/email-verification'
      fullPath: '/email-verification'
      preLoaderRoute: typeof EmailVerificationImport
      parentRoute: typeof rootRoute
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/pricing': {
      id: '/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof PricingImport
      parentRoute: typeof rootRoute
    }
    '/privacy-policy': {
      id: '/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof PrivacyPolicyImport
      parentRoute: typeof rootRoute
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterImport
      parentRoute: typeof rootRoute
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordImport
      parentRoute: typeof rootRoute
    }
    '/terms-and-conditions': {
      id: '/terms-and-conditions'
      path: '/terms-and-conditions'
      fullPath: '/terms-and-conditions'
      preLoaderRoute: typeof TermsAndConditionsImport
      parentRoute: typeof rootRoute
    }
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailImport
      parentRoute: typeof rootRoute
    }
    '/public/search': {
      id: '/public/search'
      path: '/public/search'
      fullPath: '/public/search'
      preLoaderRoute: typeof PublicSearchImport
      parentRoute: typeof rootRoute
    }
    '/settings/my-account': {
      id: '/settings/my-account'
      path: '/settings/my-account'
      fullPath: '/settings/my-account'
      preLoaderRoute: typeof SettingsMyAccountImport
      parentRoute: typeof rootRoute
    }
    '/settings/my-subscription': {
      id: '/settings/my-subscription'
      path: '/settings/my-subscription'
      fullPath: '/settings/my-subscription'
      preLoaderRoute: typeof SettingsMySubscriptionImport
      parentRoute: typeof rootRoute
    }
    '/settings/payment': {
      id: '/settings/payment'
      path: '/settings/payment'
      fullPath: '/settings/payment'
      preLoaderRoute: typeof SettingsPaymentImport
      parentRoute: typeof rootRoute
    }
    '/discover/$platform/$userSearchUUID': {
      id: '/discover/$platform/$userSearchUUID'
      path: '/discover/$platform/$userSearchUUID'
      fullPath: '/discover/$platform/$userSearchUUID'
      preLoaderRoute: typeof DiscoverPlatformUserSearchUUIDImport
      parentRoute: typeof rootRoute
    }
    '/settings/my-account/edit-profile': {
      id: '/settings/my-account/edit-profile'
      path: '/settings/my-account/edit-profile'
      fullPath: '/settings/my-account/edit-profile'
      preLoaderRoute: typeof SettingsMyAccountEditProfileImport
      parentRoute: typeof rootRoute
    }
    '/settings/payment/edit-payment': {
      id: '/settings/payment/edit-payment'
      path: '/settings/payment/edit-payment'
      fullPath: '/settings/payment/edit-payment'
      preLoaderRoute: typeof SettingsPaymentEditPaymentImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren({
  IndexRoute,
  DashboardRoute,
  DiscoverRoute,
  EmailVerificationRoute,
  ForgotPasswordRoute,
  LoginRoute,
  PricingRoute,
  PrivacyPolicyRoute,
  RegisterRoute,
  ResetPasswordRoute,
  TermsAndConditionsRoute,
  VerifyEmailRoute,
  PublicSearchRoute,
  SettingsMyAccountRoute,
  SettingsMySubscriptionRoute,
  SettingsPaymentRoute,
  DiscoverPlatformUserSearchUUIDRoute,
  SettingsMyAccountEditProfileRoute,
  SettingsPaymentEditPaymentRoute,
})

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.ts",
      "children": [
        "/",
        "/dashboard",
        "/discover",
        "/email-verification",
        "/forgot-password",
        "/login",
        "/pricing",
        "/privacy-policy",
        "/register",
        "/reset-password",
        "/terms-and-conditions",
        "/verify-email",
        "/public/search",
        "/settings/my-account",
        "/settings/my-subscription",
        "/settings/payment",
        "/discover/$platform/$userSearchUUID",
        "/settings/my-account/edit-profile",
        "/settings/payment/edit-payment"
      ]
    },
    "/": {
      "filePath": "index.ts"
    },
    "/dashboard": {
      "filePath": "dashboard.ts"
    },
    "/discover": {
      "filePath": "discover.ts"
    },
    "/email-verification": {
      "filePath": "email-verification.ts"
    },
    "/forgot-password": {
      "filePath": "forgot-password.ts"
    },
    "/login": {
      "filePath": "login.ts"
    },
    "/pricing": {
      "filePath": "pricing.ts"
    },
    "/privacy-policy": {
      "filePath": "privacy-policy.ts"
    },
    "/register": {
      "filePath": "register.ts"
    },
    "/reset-password": {
      "filePath": "reset-password.ts"
    },
    "/terms-and-conditions": {
      "filePath": "terms-and-conditions.ts"
    },
    "/verify-email": {
      "filePath": "verify-email.ts"
    },
    "/public/search": {
      "filePath": "public.search.ts"
    },
    "/settings/my-account": {
      "filePath": "settings.my-account.ts"
    },
    "/settings/my-subscription": {
      "filePath": "settings.my-subscription.ts"
    },
    "/settings/payment": {
      "filePath": "settings.payment.ts"
    },
    "/discover/$platform/$userSearchUUID": {
      "filePath": "discover_.$platform.$userSearchUUID.ts"
    },
    "/settings/my-account/edit-profile": {
      "filePath": "settings.my-account_.edit-profile.ts"
    },
    "/settings/payment/edit-payment": {
      "filePath": "settings.payment_.edit-payment.ts"
    }
  }
}
ROUTE_MANIFEST_END */
